import axios from "axios";

export const parklyPaymentSummary = async (token, account = null, date) => {
  try {
    const response = await axios.post(
      `https://new.api.parkly.mn/api/v2/report/payment-summary`,
      {
        accountNumber: account,
        startDate: date,
        endDate: date,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (response && response.data) return response.data;
    else return null;
  } catch (error) {
    console.error("Error parklyPaymentSummary:", error);
    return null;
  }
};
